export const randomHex = (bytes: number): string => {
    const a = new Uint8Array(bytes);
    try {
        globalThis.crypto.getRandomValues(a);
    } catch {
        for (let i = 0; i < bytes; i++) a[i] = Math.floor(Math.random() * 256);
    }
    let out = "";
    for (let i = 0; i < a.length; i++) out += a[i].toString(16).padStart(2, "0");
    return out;
};

/**
 * "{startMs}-{16 hex}". Сервер берёт день и время начала из префикса, а случайный
 * хвост делает ключ в бакете неугадываемым (его читают по точному имени).
 */
export const newSessionId = (nowMs: number = Date.now()): string =>
    `${Math.floor(nowMs)}-${randomHex(8)}`;

export const newId = (): string => randomHex(8);

export const docId = (rootId: string, part: number): string =>
    part > 1 ? `${rootId}-p${part}` : rootId;
